import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMomentPropType } from '../../lib/customPropTypes';
import cx from 'classnames/bind';
import moment from 'moment';
import Week from './Week';

export default class Month extends Component {

  static defaultProps = {
    utcOffset: moment.utc().utcOffset()
  };

  static propTypes = {
    day: PropTypes.object.isRequired,
    excluded: PropTypes.array,
    filtered: PropTypes.func,
    highlighted: PropTypes.func,
    included: PropTypes.array,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    onDayClick: PropTypes.func,
    selected: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.instanceOf(Date),
      isMomentPropType,
    ]),
    utcOffset: PropTypes.number
  };

  constructor(props, context) {
    super(props, context);
    this.onDayClick = this.onDayClick.bind(this);
    this.isWeekInMonth = this.isWeekInMonth.bind(this);
    this.renderWeeks = this.renderWeeks.bind(this);
  }

  onDayClick (day) {
    day.hour(this.props.day.hour())
      .minute(this.props.day.minute())
      .second(this.props.day.second())
      .millisecond(this.props.day.millisecond());
    if (this.props.onDayClick) {
      this.props.onDayClick(day);
    }
  }

  isWeekInMonth (startOfWeek) {
    const day = this.props.day;
    const endOfWeek = startOfWeek.clone().add(6, 'days');
    return startOfWeek.isSame(day, 'month') || endOfWeek.isSame(day, 'month');
  }

  renderWeeks () {
    const startOfMonth = this.props.day.clone().startOf('month').startOf('week');
    const weeks = [];
    for (let i = 0; i < 6; i++) {
      const startOfWeek = startOfMonth.clone().add(i, 'weeks');
      const cn = cx('calendar_week', {
        'calendar_week--hidden': (i === 5 && !this.isWeekInMonth(startOfWeek))
      });
      weeks.push(
        <Week
          key={i}
          day={startOfWeek}
          className={cn}
          month={this.props.day.month()}
          onDayClick={this.onDayClick}
          minDate={this.props.minDate}
          maxDate={this.props.maxDate}
          excluded={this.props.excluded}
          included={this.props.included}
          highlighted={this.props.highlighted}
          filtered={this.props.filtered}
          selected={this.props.selected}
          utcOffset={this.props.utcOffset}/>
      );
    }
    return weeks;
  }

  render () {
    return (
      <tbody className="calendar_month">
        {this.renderWeeks()}
      </tbody>
    );
  }

}
